export default function productEditParams(product) {
  const pricingSchema = product.pricing_schema;
  const pricingRanges = pricingSchema.pricing_ranges;
  const pricingRangesNull = [{
    start_quantity: '',
    end_quantity: '',
    price: '',
    overage_price: '',
  }];
  return ({
    name: product.name,
    code: product.code,
    status: product.status,
    description: product.description,
    invoice: product.invoice,
    unit: pricingSchema.unit,
    schema_type: pricingSchema.schema_type,
    pricing_schema_attributes: {
      minimum_price: pricingSchema.price.minimum_price,
      price: pricingSchema.price,
      schema_type: pricingSchema.schema_type,
      pricing_ranges_attributes: (pricingRanges || pricingRangesNull),
    },
  });
}
